import { getHours, getMinutes, set } from "date-fns";

export type TimeZone = "local" | "UTC";

export function getMilitaryHoursForMeridiem(
  militaryHours: number,
  meridiem: "AM" | "PM",
): number {
  const twelveHourValue = militaryHours % 12;
  return meridiem === "PM" ? twelveHourValue + 12 : twelveHourValue;
}

export function getTimeParts(time: Date, timeZone: TimeZone) {
  return timeZone === "UTC"
    ? { hours: time.getUTCHours(), minutes: time.getUTCMinutes() }
    : { hours: getHours(time), minutes: getMinutes(time) };
}

export function setTimeParts(
  time: Date,
  values: { hours?: number; minutes?: number },
  timeZone: TimeZone,
): Date {
  if (timeZone === "local") {
    return set(time, values);
  }

  const nextTime = new Date(time);
  if (values.hours !== undefined) {
    nextTime.setUTCHours(values.hours);
  }
  if (values.minutes !== undefined) {
    nextTime.setUTCMinutes(values.minutes);
  }
  return nextTime;
}
